import api, { armorAPI } from '~/services/api';

function getParcelTemplates() {
  return armorAPI.request({
    url: `setting/parcel_templates`,
    method: 'GET',
  });
}

function getCarrierParcelTemplates(limit = 250) {
  return api.request({
    url: `parcel_templates?results=${limit}`,
    method: 'GET',
  });
}

export { getParcelTemplates, getCarrierParcelTemplates };
